import React from 'react'

const fmt = (v) => (v || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })
const pct = (v) => ((v || 0) * 100).toFixed(1) + '%'

const SummaryCards = ({ summary, serviceEstimate }) => {
  if (!summary) return null

  const { totalCost, totalSell, margin, totalItems, coveredItems, coverageMode } = summary
  const coveragePct = totalItems ? Math.round((coveredItems / totalItems) * 100) : 0

  const se = serviceEstimate && serviceEstimate.hasData ? serviceEstimate : null
  const displayCost = se ? se.totalCost : totalCost
  const displaySell = se ? se.totalSell : totalSell
  const displayMargin = se ? se.margin : margin
  const marginVal = (displayMargin || 0) * 100
  const marginWarn = marginVal < 10

  return (
    <div className="stat-row">
      <div className="stat-card">
        <span className="eyebrow">Total Cost{se ? ' (service est)' : ''}</span>
        <span className="num">{fmt(displayCost)}</span>
        {se && totalCost > 0 && <span className="sub">Line items: {fmt(totalCost)}</span>}
        {!se && <span className="sub">Service estimate &middot; {summary.serviceCount || 0} services</span>}
      </div>

      <div className="stat-card">
        <span className="eyebrow">Total Sell{se ? ' (service est)' : ''}</span>
        <span className="num">{fmt(displaySell)}</span>
        {se && totalSell > 0 && <span className="sub">Line items: {fmt(totalSell)}</span>}
        {!se && <span className="sub">No markup applied</span>}
      </div>

      <div className="stat-card">
        <span className="eyebrow">Margin</span>
        <span className={`num${marginWarn ? ' warn' : ''}`}>{pct(displayMargin)}</span>
        <span className="sub">Target 20%{marginWarn ? ' \u00b7 below floor' : ''}</span>
        <div className="meter"><i className={marginWarn ? 'risk' : ''} style={{ width: `${Math.min(marginVal / 20 * 100, 100)}%` }} /></div>
      </div>

      <div className="stat-card">
        <span className="eyebrow">{coverageMode === 'assembly' ? 'Assembly Coverage' : 'Coverage'}</span>
        <span className={`num${coveragePct === 0 && totalItems > 0 ? ' warn' : ''}`}>{coveredItems || 0} / {totalItems || 0}</span>
        <span className="sub">{coveragePct === 0 ? 'No items costed yet' : `${coveragePct}% covered`}{se ? ` \u00b7 ${se.serviceCount} services` : ''}</span>
        <div className="meter"><i className={coveragePct === 0 ? 'risk' : ''} style={{ width: `${coveragePct}%` }} /></div>
      </div>
    </div>
  )
}

export default SummaryCards
